import React from 'react';
import {useTranslation} from 'react-i18next';
import useTrascinaGiu from '../../utils/useTrascinaGiu';
import IconaNova from './IconaNova';

/**
 * IL PANNELLO DAL BASSO del telefono: lo aprono i tasti della barra (Giochi,
 * Conto, Versa, Registrati). Sale da dietro la barra e le resta sopra, cosi'
 * il tasto acceso si vede e un secondo tocco lo richiude.
 *
 * Si chiude con la X, toccando fuori, trascinandolo giu' dalla maniglia, con
 * Esc, o andando in un'altra pagina (lo fa il guscio). Mentre e' aperto la
 * pagina dietro non scorre.
 *
 * Resta sempre montato: aprire e chiudere e' una classe, cosi' scorre su e
 * giu' invece di comparire di colpo. Chiuso e' `visibility: hidden`: i suoi
 * collegamenti non si raggiungono col tasto Tab ne' dal lettore di schermo.
 * Dal computer in su non c'e' (non c'e' la barra che lo apre).
 *
 * `alto`: sempre alto quasi quanto lo schermo, e scorre solo la parte
 * `.nova-foglio-scorre` (i Fornitori: cambiando Casinò / Live casino o
 * cercando non salta su e giu').
 *
 * `finestra`: sul telefono e' il pannello di sempre; dal tablet e dal
 * computer in su (oltre 560 px, come la finestra di Accedi) diventa una
 * finestra al centro dello schermo, non attaccata in fondo. Lo usa
 * Registrati, che dal computer si apre dalla testata e non dalla barra.
 *
 * `indietro` ({testo, onClick}): un tasto «‹ testo» prima del titolo, per
 * tornare al pannello da cui si e' venuti (Fornitori torna a Giochi).
 */
export default function FoglioNova({aperto, titolo, onChiudi, alto, finestra, indietro, children}) {
  const {t} = useTranslation();
  const [rif, presa] = useTrascinaGiu(onChiudi);

  React.useEffect(() => {
    if (!aperto) return undefined;
    const alTasto = (e) => { if (e.key === 'Escape') onChiudi(); };
    document.addEventListener('keydown', alTasto);
    const eraCosi = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', alTasto);
      document.body.style.overflow = eraCosi;
    };
  }, [aperto, onChiudi]);

  return (
    <>
      <div className={'nova-foglio-velo' + (finestra ? ' al-centro' : '') + (aperto ? ' aperto' : '')} onClick={onChiudi} aria-hidden={'true'}/>
      <section ref={rif} className={'nova-foglio' + (alto ? ' alto' : '') + (finestra ? ' al-centro' : '') + (aperto ? ' aperto' : '')} role={'dialog'}
        aria-modal={aperto ? 'true' : undefined} aria-label={titolo} aria-hidden={aperto ? undefined : 'true'}>
        <div className={'nova-foglio-presa'} {...presa}>
          <span className={'nova-maniglia'} aria-hidden={'true'}/>
          <div className={'nova-foglio-testa'}>
            {indietro && (
              <button type={'button'} className={'nova-foglio-indietro'} onClick={indietro.onClick}>
                <span aria-hidden={'true'}>‹</span>{indietro.testo}
              </button>
            )}
            <h3>{titolo}</h3>
            <button type={'button'} className={'nova-foglio-x'} onClick={onChiudi} aria-label={t('Chiudi')}>
              <IconaNova nome={'x'} misura={18}/>
            </button>
          </div>
        </div>
        {children}
      </section>
    </>
  );
}
